module.exports = __webpack_public_path__ + "static/media/warming.f3044dfe.jpg";